import { useContext } from 'react';
import { AchRelationshipsTableContext, IAchRelationshipsTableContext } from './AchRelationshipsTableContext';

export const useAchRelationshipsTable = () => useContext<IAchRelationshipsTableContext>(AchRelationshipsTableContext);
